import {
  compose,
  withPropsOnChange,
  withProps,
} from 'recompose'

import * as R from 'ramda'

import { esuzStatusesTransport } from './esuzStatusesTransport'
import { esuzIssueTransport } from './esuzIssueTransport'
import prepareEsuzIssueForWidget from './prepareEsuzIssueForWidget'


const withEsuzIssueOnView = compose(
  esuzStatusesTransport,
  withProps(({ data: { esuz } }) => ({
    esuzIssueId: esuz,
  })),
  esuzIssueTransport,
  withPropsOnChange([`esuzIssues`, `esuzStatuses`], ({ esuzIssues, setIssueLinkData, esuzStatuses }) => {
    if (!R.isEmpty(esuzIssues) && !R.isEmpty(esuzStatuses)) {
      const tempIssue = R.head(prepareEsuzIssueForWidget(esuzIssues, esuzStatuses))
      setIssueLinkData(tempIssue)
    }
  }),
)


export default withEsuzIssueOnView
